<template>
  <div :class="classList">
    <slot />
  </div>
</template>

<script>
/**
 * Body.vue
 */
export default {
  data () {
    return {}
  },

  computed: {
    classList () {
      return [
        'flex-grow flex flex-col overflow-hidden',
      ]
    },
  },
}
</script>
